import useSWR from 'swr';
import SoftCreditPullService from 'services/SoftCreditPullService';
import { getKey, Resource } from '../key';

export const useSoftCreditPullReport = (dealId: string) =>
  useSWR(
    getKey(Resource.SOFT_CREDIT_PULL_REPORT, { dealId }),
    async (key) => SoftCreditPullService.getReportUrl(key.params.dealId),
    {
      // don't regenerate signed URLs too often as changing the URL will
      // cause the iframe to reload
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
